var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ox__Integration=OX, Size=24",
    className: "ox__Integration=OX, ox__Size=24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ox__Layer 1",
    className: "ox__Layer ox__1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ox__Group 38876",
    className: "ox__Group ox__38876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ox__Vector",
    fill: "#1E144D",
    d: "M20.315 4.83a2.01 2.01 0 0 1-2.013 2.013h-2.944A4.728 4.728 0 0 0 12 8.261a4.727 4.727 0 0 0-3.36-1.418H5.704A2.012 2.012 0 0 1 3.69 4.831v-.792H1v.792a4.709 4.709 0 0 0 4.703 4.703h2.938c2.455 0 3.278 3.259 3.286 3.293l.065.27.097-.258c.014-.033 1.271-3.303 3.269-3.303h2.939A4.708 4.708 0 0 0 23 4.833V4.04h-2.685v.792Z",
    className: "ox__Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ox__Vector_2",
    fill: "#1E144D",
    d: "m12.005 16.38-3.138-5.268-3.512-.012 5.402 8.847.422.008h1.66l.44.008 5.403-8.857h-3.496l-3.18 5.273Z",
    className: "ox__Vector"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOx);
export default __webpack_public_path__ + "static/media/Ox.b653dafa941f1ee54471d3bfffda013f.svg";
export { ForwardRef as ReactComponent };